(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_typhur-video-swipe-page"] && !Shopify.designMode) return;
  try {
    Array.from(document.querySelectorAll(".typhur-swipe-video--page .repeat")).forEach(element => {
    element.addEventListener("click", (e) => {
        const videoElement = e.currentTarget.closest(".typhur-swipe-video--page").querySelector('video')
        videoElement.load()
        videoElement.play()
    })
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bnpl-block"] && !Shopify.designMode) return;
  try {
    const details = document.querySelector(".custom_bnpl_display_block>details")
    const details__summary = details.querySelector("summary")
    const details__content = details.querySelector(".bnpl_card__content")

    //handle interactions
    details.addEventListener("mouseleave", (e)=> {
        details.removeAttribute("open")
    })

    document.addEventListener("scroll", (e)=> {
        details.removeAttribute("open")
    })

    //handle data

    // window.addEventListener("load", (event) => {
    //     const option_values = details__content.querySelectorAll("[data-installment-value]")
        
        
    //     let largest_value = parseInt(option_values[0].dataset.installmentValue)
    //     Array.from(option_values).forEach(value => {
    //         if (parseInt(value.dataset.installmentValue) < largest_value) {
    //             largest_value = parseInt(value.dataset.installmentValue)
    //         }
    //     })

    //     const largest_value__formatted = parseFloat(largest_value / 100)


    //     if (largest_value__formatted !== NaN) {
    //         details.querySelector(".bnpl_card__lowest_value").innerText = ` - from R${largest_value__formatted}`
    //     }
    // });
    let is_data_ready = false
    
    //
    window.addEventListener("bnpl_loaded", (e) => {
        is_data_ready = true
    })

    const start_time = Date.now()
    const data_interval = setInterval(() => {
        if (is_data_ready) {
            const option_values = details__content.querySelectorAll("[data-installment-value]")
        
            let largest_value = parseInt(option_values[0].dataset.installmentValue)

            Array.from(option_values).forEach(value => {
    
                if (parseInt(value.dataset.installmentValue) < largest_value) {
                    largest_value = parseInt(value.dataset.installmentValue)
                }
            })

            const largest_value__formatted = parseFloat(largest_value / 100)


            if (largest_value__formatted !== NaN) {
                 const fromValSpan = details.querySelector(".bnpl_card__lowest_value")
                 if (fromValSpan.dataset.instock === "true") {
                //     fromValSpan.innerText = ` - from R${largest_value__formatted}`
                        details.querySelector(".bnpl_card__lowest_value").innerText = ` - from R${largest_value__formatted}`
                 }
            }

            clearInterval(data_interval)
        } else if (Date.now() - start_time >= 5000) {
            clearInterval(data_interval)
        }
    }, 500)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["typhur-2-page-swipe-video"] && !Shopify.designMode) return;
  try {
    const pageWrapper = document.querySelector(".typhur-swipe-video__page-wrapper")
  let isDragging = false
  let dragStartX
  let scroll

  const startDragging = (e) => {
    e.preventDefault()
    pageWrapper.style.scrollSnapType = "none"
    isDragging = true
    dragStartX = e.pageX - pageWrapper.offsetLeft
    scroll = pageWrapper.scrollLeft
  }

  const stopDragging = (e) => {
    pageWrapper.style.scrollSnapType = "x mandatory"
    isDragging = false
    
  }

  const drag = (e) => {
    if (isDragging) {
      const x = e.pageX - pageWrapper.offsetLeft
      const delta = x - dragStartX
      window.requestAnimationFrame(() => pageWrapper.scrollLeft = (scroll - delta))
    }
  }

  pageWrapper.addEventListener('mousedown', startDragging)
  pageWrapper.addEventListener('mouseup', stopDragging)
  pageWrapper.addEventListener('mousemove', drag)
  pageWrapper.addEventListener('mouseout', stopDragging)
  } catch(e) { console.error(e); }
})();

})();
